import React from 'react';
import PropTypes from 'prop-types';
import URL from 'urijs';
import classnames from 'classnames';
import _ from 'underscore';
import { PersonRegular } from '@fluentui/react-icons';
import { Tooltip } from '@fluentui/react-components';
import { Dropdown, Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { RootCloseWrapper } from 'react-overlays';
import { getStyles } from './getStyles';

import { DefaultAvatarSrc } from './default-avatar';

export class MeControlUnthemed extends React.PureComponent {
  state = { panelVisible: false, forceShowToolTip: false, tooltipVisible: false };

  closePanel = () => {
    this.setState({
      panelVisible: false,
    });
  };

  togglePanel = () => {
    this.setState(({ panelVisible }) => ({
      panelVisible: !panelVisible,
    }));
  };

  toggleFocus = () => {
    this.setState({ forceShowToolTip: true });
  };

  toggleBlur = () => {
    this.setState({ forceShowToolTip: false });
  };

  renderAvatar = () => {
    const {
      classes,
      avatarSrc,
      forNewGlobalMenu,
    } = this.props;

    if (forNewGlobalMenu) {
      return (
        <div className={classes.avatarInBreadcrumbContainerNew} >
          <PersonRegular />
        </div>
      );
    }

    return (
      <div className={classes.avatarInBreadcrumbContainer}>
        <img src={avatarSrc} className={classes.avatarInBreadcrumb} alt="" />
      </div>
    );
  };

  renderToggle = () => {
    const {
      classes,
      user,
      isMultiUser,
      isFullBreadcrumbMode,
      forNewGlobalMenu,
    } = this.props;

    return (
      <Tooltip
        visible={(this.state.tooltipVisible || this.state.forceShowToolTip) && forNewGlobalMenu && !isFullBreadcrumbMode}
        onVisibleChange={(_ev, data) => this.setState({ tooltipVisible: data.visible })}
        content={user.Name}
        relationship="label"
      >
        <div className={classnames(classes.breadcrumbContainer)} >
          {forNewGlobalMenu && this.renderAvatar()}
          { isFullBreadcrumbMode && (
          <div className={classnames(classes.userInfoContainer, forNewGlobalMenu ? classes.userInfoContainerNew : '', 'current-customer')}>
            <span className={classes.userLine}>
              {user.Name}
            </span>
            {isMultiUser && !_.isEmpty(user.CurrentCustomer) && (
            <div className={classes.customerLine}>
              <span className={classes.customerName}>
                {user.CurrentCustomer && user.CurrentCustomer.Name}
              </span>
              <span className={classes.customerId}>
                {user.CurrentCustomer && user.CurrentCustomer.Number}
              </span>
              <Glyphicon glyph="ba-ChevronDown" className={classes.bottomChevronDown} />
            </div>)
          }
          </div>)
          }
          {!forNewGlobalMenu && this.renderAvatar()}
        </div>
      </Tooltip>
    );
  };

  render() {
    const {
      classes,
      i18n,
      perfMarker,
      CustomMenu,
      forNewGlobalMenu,
    } = this.props;

    return (
      <Dropdown
        id="user-center"
        className={classnames(classes.dropdown, forNewGlobalMenu ? classes.dropdownNew : '', 'me-control-dropdown')}
        open={this.state.panelVisible}
        onToggle={this.togglePanel}
        onFocus={this.toggleFocus}
        onBlur={this.toggleBlur}
      >
        <Dropdown.Toggle
          noCaret
          className={classnames(classes.dropdownButton, forNewGlobalMenu ? classes.dropdownButtonNew : '')}
          aria-label={i18n.getString(_TL_('Select an customer or sign out'))}
        >
          {this.renderToggle()}
        </Dropdown.Toggle>
        <RootCloseWrapper
          onRootClose={this.closePanel}
          disabled={!this.state.panelVisible}
          bsRole="menu"
        >
          <CustomMenu
            {...this.props}
            closePanel={this.closePanel}
            panelVisible={this.state.panelVisible}
            perfMarker={perfMarker}
          />
        </RootCloseWrapper>
      </Dropdown>
    );
  }
}

MeControlUnthemed.propTypes = {
  user: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    IsAggregator: PropTypes.bool.isRequired,
    Name: PropTypes.string.isRequired,
    FullName: PropTypes.string.isRequired,
    UserRole: PropTypes.string.isRequired,
    CurrentCustomer: PropTypes.shape({
      Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      Name: PropTypes.string,
      Number: PropTypes.string,
    }),
  }).isRequired,
  classes: PropTypes.shape({
    dropdownContainer: PropTypes.string,
    avatarInProfileCard: PropTypes.string,
    avatarInToggleButton: PropTypes.string,
    dropdownTitleContainer: PropTypes.string,
    customerSelectorContainer: PropTypes.string,
    profileCard: PropTypes.string,
    profileCardRightSection: PropTypes.string,
    profileCardLink: PropTypes.string,
    dropdown: PropTypes.string,
    dropdownButton: PropTypes.string,
    breadcrumbContainer: PropTypes.string,
    userInfoContainer: PropTypes.string,
    userLine: PropTypes.string,
    customerLine: PropTypes.string,
    customerName: PropTypes.string,
    customerId: PropTypes.string,
    avatarInBreadcrumbContainer: PropTypes.string,
    bottomChevronDown: PropTypes.string,
    avatarInBreadcrumb: PropTypes.string,
    userInfoContainerNew: PropTypes.string,
    dropdownButtonNew: PropTypes.string,
    dropdownNew: PropTypes.string,
    avatarInBreadcrumbContainerNew: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  customerService: PropTypes.shape({
    getCustomers: PropTypes.func.isRequired,
  }).isRequired,
  ccBaseUrl: PropTypes.string.isRequired,
  signOutUrl: PropTypes.string,
  supportUrl: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  customerUrlUpdater: PropTypes.func,
  avatarSrc: PropTypes.string,
  isMultiUser: PropTypes.bool,
  hideCustomerSelector: PropTypes.bool,
  isFullBreadcrumbMode: PropTypes.bool,
  fallbackLinkFlags: PropTypes.shape({}),
  renderLink: PropTypes.func,
  perfMarker: perfMarkerPropTypes,
  CustomMenu: PropTypes.elementType,
  isDarkThemeEnabled: PropTypes.bool,
  preferenceService: PropTypes.shape({}),
  forNewGlobalMenu: PropTypes.bool,
};

const DefaultRenderLink = ({ href, className, children }) =>
  <a href={href} className={className}>{children}</a>;
DefaultRenderLink.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

MeControlUnthemed.defaultProps = {
  isMultiUser: false,
  isDarkThemeEnabled: false,
  hideCustomerSelector: false,
  avatarSrc: DefaultAvatarSrc,
  isFullBreadcrumbMode: true,
  customerUrlUpdater: ({ url, cid, uid }) =>
    new URL(url).removeQuery('aid').setQuery('cid', cid).setQuery('uid', uid)
      .toString(),
  fallbackLinkFlags: {
    viewAllCustomers: false,
    customerManagement: false,
    supportDashboard: false,
  },
  renderLink: DefaultRenderLink,
  perfMarker: null,
  CustomMenu: null,
  signOutUrl: null,
  preferenceService: null,
  forNewGlobalMenu: false,
};

export const MeControlBase = withDefaultStyles(MeControlUnthemed, getStyles);
